import type {
  CreatorOutreachCompletePayload,
  CreatorOutreachFailedPayload,
} from '@fluenceur/types';
import { BrandEventPusherService } from './brand-event-pusher-service';

export const creatorOutreachPusherService = new BrandEventPusherService<
  CreatorOutreachCompletePayload,
  CreatorOutreachFailedPayload
>({
  debugLabel: 'CreatorOutreachPusher',
  completeEvent: 'creator-outreach-complete',
  failedEvent: 'creator-outreach-failed',
});
